import Pet from "./Pet";

export default class PetDragon extends Pet {
    constructor() {
        super("guardian_pet", Pet.TYPE_DRAGON);
    }

    init() {
        super.init(P3.utils.selectRandom(["pet3"]));
    }
}